module.exports = __webpack_public_path__ + "img/circularStrategy1.e29fd26d.png";